import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const VisibilityIcon = ({
  visible,
  onClick
}: {
  visible: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      className="text-ctb-grey-300 transition hover:text-ctb-grey-800"
      onClick={onClick}
    >
      {visible ? (
        <MdVisibilityOff className="h-4 w-4" />
      ) : (
        <MdVisibility className="h-4 w-4" />
      )}
    </div>
  );
};

export default VisibilityIcon;
